import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider, FieldArray } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from '../Global';
import { toast } from "react-toastify";
import $ from "jquery";
import "react-toastify/dist/ReactToastify.css";
const ConsumableEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [supplierlist, setSupplierlist] = useState([]);
  const [valueContents, setValueContents] = useState([]);
  const [permission, setPermission] = useState({});


  useEffect(() => {
    setPermission(FindModuleById(121)); 
    console.log(permission);
    axios
      .get(`/consumables/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
       
        setValue(response.data.data.product);
        setValueContents(response.data.data.product.suppliers);

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      consumable_name: value.consumable_name,
      description: value.description,
      supplier: value.supplier,
      average_level:value.average_level,
      critical_level:value.critical_level,
      packaging:(value.packaging == '1')?true:false,
      supplierarr: valueContents,

    },
    enableReinitialize: true,

    onSubmit: (values, { setSubmitting }) => { 
         axios
        .post("/consumables/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {

          delete backendErrors['error'];
          $("#form-submit").text("Update Consumable");
          setSubmitting(false);
          if (response.data.code === 200) {
            setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            setSubmitting(false);
            setTimeout(() => {
              window.location.href = "/consumables";
            }, 1000);
          }
            else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
         
        })
        .catch((error) => {
          console.log(error);

         // actions.setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {

    axios.post("/suppliers/listing-not-Traders-farmers",{}, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if(response.data.code === 200){
        let supplier_types = response.data.data.suppliers;
       // setPackagingTypesLists(materials_payment_status);
        let supplier_typesList = supplier_types.map((ord, index) => ({
          label:  ord.name ,
          value: ord.id,
          key: `supplierr-${index}`,
        }));
        setSupplierlist(supplier_typesList);
    }else{
        console.log("API response is not an array");
      }
              
    })
    .catch((error) => {
      console.log(error);
    });

}, []);

const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Consumable</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/consumables">Consumables</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Consumable </h4>
                    {permission && permission.update == 1 && (
                    <FormikProvider value={formik}>
                    <form action="#" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                             
                              <div className="form-group">
                                <label>Consumable Name</label>
                                <input
                                  type="text"
                                  name="consumable_name"
                                  value={formik.values.consumable_name}
                                  className={
                                    backendErrors.consumable_name
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                 onBlur={formik.handleBlur}
                                />
                               
                                <small>
                                  {backendErrors.consumable_name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.consumable_name}
                                    </span>
                                  )}
                                </small> 
                              </div>
                            </div>
                            <div className="col-md-3">
                          <div className="form-group">
                            <label> Critical Level</label>
                            <input
                             type="text"
                             onKeyPress={(event) => {
                               // Allow only numbers (0-9)
                               if (!/^[0-9]$/.test(event.key)) {
                               event.preventDefault();
                               }
                             }}
                              name="critical_level"
                              value={formik.values.critical_level}
                              className= "form-input form-control"
                                onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.critical_level && (
                                <span className="form-error mt-1">
                                  {backendErrors.critical_level}
                                </span>
                              )}
                            </small>
                          </div>
                        
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> Average Level</label>
                            <input
                               type="text"
                               onKeyPress={(event) => {
                                 // Allow only numbers (0-9)
                                 if (!/^[0-9]$/.test(event.key)) {
                                 event.preventDefault();
                                 }
                               }}
                              name="average_level"
                              value={formik.values.average_level}
                              className= "form-input form-control"
                                onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.average_level && (
                                <span className="form-error mt-1">
                                  {backendErrors.average_level}
                                </span>
                              )}
                            </small>
                          </div>
                        
                        </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                <label>Description</label>
                                <input
                                  type="text"
                                  value={formik.values.description}
                                  name="description"
                                  className={
                                    backendErrors.description
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.description && (
                                    <span className="form-error mt-1">
                                      {backendErrors.description}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                            <div className="custom-control custom-checkbox" >
                              <input
                                type="checkbox"
                                className="form-check-input packaging-class"
                                id="cb1"
                                name="packaging"
                                value={formik.values.packaging}
                                checked={(formik.values.packaging == '1')?'checked':""}
                                
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  //setFieldValue("packaging", e.target.checked);  // Update form value on change
                                
                                  customHandleInput(e);
                                }}
                                  onBlur={formik.handleBlur}
                              />
                              <label
                                className="custom-control-label ms-1"
                                htmlFor="cb1"
                                style={{paddingTop:"10px"}}
                              >
                                Packaging
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add Suppliers
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="supplierarr"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpers.push({
                                    supplier: "",
                                    unit_price: "",
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.supplierarr.map((friend, index) => (
                                    <tr key={index}>
                                      
                                     
                                      <td>
                                        <div className="form-group status">
                                          <label>Supplier</label><br/>
                                          {supplierlist.length > 0 && (
                                            <Select
                                            name={`supplierarr[${index}].supplier`}
                                            options={supplierlist}
                                            value={supplierlist .find(option => option.value == formik.values.supplierarr[index].supplier) || null} // Ensure correct format
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue(`supplierarr[${index}].supplier`, selectedOption.value); // ✅ Store only value in Formik
                                              customHandleInput({
                                                target: {
                                                  name: `supplierarr[${index}].supplier`,
                                                  value: selectedOption.value, // ✅ Ensure only value is passed
                                                },
                                              });
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select" 
                                          />
                                          )}
                                          
                                        </div>
                                      </td>
                                     
                                     
                                      <td>
                                        <div className="form-group status">
                                          <label>Unit Price</label>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`supplierarr[${index}].unit_price`}
                                            value={
                                              formik.values.supplierarr[index]
                                                .unit_price
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                             />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />
                        <small>
                              {backendErrors.status  && (
                                  <span className="form-error mt-1">
                                    {backendErrors.status}
                                  </span>
                                )}

                              {backendSuccess && (
                              <div className="from-success mt-1">
                                {backendSuccess}
                              </div>
                            )}
                        </small>
                        <div className="text-end mt-4">
                          <button
                            type="submit" id="form-submit"
                            className="btn btn-primary"
                            disabled={formik.isSubmitting}
                          >
                            Update Consumable
                          </button>
                        </div>
                    </form>
                    </FormikProvider>
                   
                   )}
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ConsumableEdit;
